var WalletViewRouteName;
(function(WalletViewRouteName2) {
  WalletViewRouteName2["BONUSES"] = "bonuses";
  WalletViewRouteName2["DEPOSIT"] = "deposit";
  WalletViewRouteName2["HISTORY"] = "history";
  WalletViewRouteName2["WITHDRAW"] = "withdraw";
})(WalletViewRouteName || (WalletViewRouteName = {}));
var WalletHistoryViewRouteName;
(function(WalletHistoryViewRouteName2) {
  WalletHistoryViewRouteName2["GAMING"] = "gaming";
  WalletHistoryViewRouteName2["PAYMENTS"] = "payments";
  WalletHistoryViewRouteName2["SEARCH"] = "search";
})(WalletHistoryViewRouteName || (WalletHistoryViewRouteName = {}));
var HistoryType;
(function(HistoryType2) {
  HistoryType2["GAMING"] = "gaming";
  HistoryType2["PAYMENTS"] = "payments";
  HistoryType2["BONUSES"] = "bonuses";
})(HistoryType || (HistoryType = {}));

export { HistoryType, WalletHistoryViewRouteName, WalletViewRouteName };
